import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** Scroll หน้าหลักขึ้นบนสุด (รองรับ Safari ที่ scroll ที่ html/body) */
export function scrollPageToTop(behavior: ScrollBehavior = 'auto'): void {
  try {
    window.scrollTo({ top: 0, left: 0, behavior })
  } catch {
    window.scrollTo(0, 0)
  }
  if (document.documentElement) document.documentElement.scrollTop = 0
  if (document.body) document.body.scrollTop = 0
}

/**
 * ทุกครั้งที่เปลี่ยน route ให้ scroll กลับบนสุด
 * กันกรณีกดลิงก์จากท้ายหน้ายาวแล้วหน้าใหม่ยังค้างตำแหน่ง scroll เดิม
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    scrollPageToTop('auto')
  }, [pathname, search])

  return null
}
